import React from 'react';
import MultipleChoices from "../common/MultipleChoices";

const Checkboxes = (props:any) => {
  return <MultipleChoices {...props} />
}

export default Checkboxes;
